export const paths = {
  propertyDetails: (pid?: string) => (pid ? `/property-details/${pid}` : '/property-details'),
}
export const propertyDetailsPaths = {}
